


.actions
{
  gap: 15px;

  .btnSuccess
  {
    cursor: pointer;
    &:hover
    {
      background-color: var(--beigedark);
    }
  }

  .btnCancel {
    cursor: pointer;
    background: white;
    color: var(--font-color);
    border: 1px solid var(--beigedarker);
    border-radius: var(--border-radius);
    &:hover
    {
      background-color: var(--beigelight);
    }
  }

  .title {
    color: red;
  }

  .htmlContainer {
    color: blue;
  }
}
